import React from "react";
import Badge from "../components/badge";

function About() {
  return (
    <section className="section-about" id="skills">
      <h4 className="heading-secondary heading-secondary--color u-margin-top-big">
        Skills
      </h4>
      <h4 className="heading-primary heading-primary--sub u-margin-bottom-medium">
        Specializing In
      </h4>

      <div className="frontend-box">
        <h3 className="heading-tertiary heading-tertiary--sub">
          Programming Languages:
        </h3>

        <div className="badge-group">
          <Badge
            link={
              "https://img.shields.io/badge/JavaScript-323330?style=for-the-badge&logo=javascript&logoColor=F7DF1E"
            }
            name={"Javascript logo"}
          ></Badge>
          <Badge
            link={
              "https://img.shields.io/badge/Dart-0175C2?style=for-the-badge&logo=dart&logoColor=white"
            }
            name={"Dart logo"}
          ></Badge>
          <Badge
            link={
              "https://img.shields.io/badge/C%2B%2B-00599C?style=for-the-badge&logo=c%2B%2B&logoColor=white"
            }
            name={"C++ logo"}
          ></Badge>
          <Badge
            link={
              "https://img.shields.io/badge/Python-3776AB?style=for-the-badge&logo=python&logoColor=white"
            }
            name={"Python logo"}
          ></Badge>
        </div>
      </div>
      <div className="frontend-box">
        <h3 className="heading-tertiary heading-tertiary--sub">
          Frontend Development:
        </h3>
        <div className="badge-group">
          <Badge
            link={
              "https://img.shields.io/badge/html5-%23E34F26.svg?style=for-the-badge&logo=html5&logoColor=white"
            }
            name={"html logo"}
          />
          <Badge
            link={
              "https://img.shields.io/badge/css3-%231572B6.svg?style=for-the-badge&logo=css3&logoColor=white"
            }
            name={"css logo"}
          />
          <Badge
            link={
              "https://img.shields.io/badge/Sass-CC6699?style=for-the-badge&logo=sass&logoColor=white"
            }
            name={"sass logo"}
          />
          <Badge
            link={
              "https://img.shields.io/badge/Bootstrap-563D7C?style=for-the-badge&logo=bootstrap&logoColor=white"
            }
            name={"bootstrap logo"}
          />
          <Badge
            link={
              "https://img.shields.io/badge/Vue.js-35495E?style=for-the-badge&logo=vue-dot-js&logoColor=4FC08D"
            }
            name={"vuejs logo"}
          />
          <Badge
            link={
              "https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB"
            }
            name={"reactjs logo"}
          />
          <Badge
            link={
              "https://img.shields.io/badge/Redux-593D88?style=for-the-badge&logo=react&logoColor=61DAFB"
            }
            name={"redux logo"}
          />
          <Badge
            link={
              "https://img.shields.io/badge/Vuetify-1867C0?style=for-the-badge&logo=vuetify&logoColor=AEDDFF"
            }
            name={"vuetify logo"}
          />
          <Badge
            link={
              "https://img.shields.io/badge/Qt-%23217346.svg?style=for-the-badge&logo=Qt&logoColor=white"
            }
            name={"qt logo"}
          />
          <Badge
            link={
              "https://img.shields.io/badge/Tailwind_CSS-38B2AC?style=for-the-badge&logo=tailwind-css&logoColor=white"
            }
            name={"tailwind logo"}
          />
          {/* <Badge link={""} name={""}></Badge> */}
        </div>
      </div>
      <div className="frontend-box">
        <h3 className="heading-tertiary heading-tertiary--sub">
          Backend Development:
        </h3>
        <div className="badge-group">
          <Badge
            link={
              "https://img.shields.io/badge/Node.js-43853D?style=for-the-badge&logo=node-dot-js&logoColor=white"
            }
            name={"node logo"}
          />

          <Badge
            link={
              "https://img.shields.io/badge/Express.js-404D59?style=for-the-badge&logo=express&logoColor=white"
            }
            name={"express logo"}
          ></Badge>
          <Badge
            link={
              "https://img.shields.io/badge/Flask-000000?style=for-the-badge&logo=flask&logoColor=white"
            }
            name={"flask logo"}
          ></Badge>
          <Badge
            link={
              "https://img.shields.io/badge/Django-092E20?style=for-the-badge&logo=django&logoColor=white"
            }
            name={"django logo"}
          ></Badge>
          <Badge
            link={
              "https://img.shields.io/badge/MongoDB-4EA94B?style=for-the-badge&logo=mongodb&logoColor=white"
            }
            name={"Mongodb logo"}
          ></Badge>
          <Badge
            link={
              "https://img.shields.io/badge/MySQL-00000F?style=for-the-badge&logo=mysql&logoColor=white"
            }
            name={"My sql logo"}
          ></Badge>
          <Badge
            link={
              "https://img.shields.io/badge/PostgreSQL-316192?style=for-the-badge&logo=postgresql&logoColor=white"
            }
            name={"Postgres logo"}
          ></Badge>
          {/* <Badge link={""} name={""}></Badge> */}
        </div>
      </div>
      <div className="frontend-box">
        <h3 className="heading-tertiary heading-tertiary--sub">
          Mobile App Development:
        </h3>
        <div className="badge-group">
          <Badge
            link={
              "https://img.shields.io/badge/Flutter-02569B?style=for-the-badge&logo=flutter&logoColor=white"
            }
            name={"flutter logo"}
          />

          {/* <Badge link={""} name={""}></Badge> */}
        </div>
      </div>
    </section>
  );
}

export default About;
